import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { GridCard } from '../';
import { CaseStudy } from '@layouts/CaseStudies/types';
import useMediaQuery from '@utils/hooks/useMediaQuery';

import * as styles from './CaseStudiesGrid.module.scss';

export const CaseStudiesGrid: React.FC<{
	data: CaseStudy[];
}> = ({ data }) => {
	const [grid, setGrid] = useState({
		firstColumn: {
			data: [],
			additionalStyles: '',
			condition: true,
		},
		secondColumn: {
			data: [],
			additionalStyles: '',
			condition: true,
		},
		thirdColumn: {
			data: [],
			additionalStyles: '',
			condition: true,
		},
	});
	const isNotXLScreen = useMediaQuery('xl');

	useEffect(() => {
		const firstColumnCases = [];
		const secondColumnCases = [];
		const thirdColumnCases = [];
		const length = data.length;
		const reminder = length % (isNotXLScreen ? 2 : 3);
		const step = isNotXLScreen ? 2 : 3;

		for (let i = 0; i < length - reminder; i = i + step) {
			firstColumnCases.push(data[i]);
			secondColumnCases.push(data[i + 1]);
			if (!isNotXLScreen) thirdColumnCases.push(data[i + 2]);
		}

		if (reminder) {
			const lastIndex = length - 1;
			const secondToLastIndex = length - 2;
			switch (reminder) {
				case 1:
					firstColumnCases.push(data[lastIndex]);
					break;
				case 2:
					firstColumnCases.push(data[secondToLastIndex]);
					secondColumnCases.push(data[lastIndex]);
					break;
			}
		}

		setGrid({
			firstColumn: {
				data: firstColumnCases,
				additionalStyles: styles.first,
				condition: true,
			},
			secondColumn: {
				data: secondColumnCases,
				additionalStyles: '',
				condition: true,
			},
			thirdColumn: {
				data: thirdColumnCases,
				additionalStyles: styles.third,
				condition: !isNotXLScreen,
			},
		});
	}, [data, isNotXLScreen]);

	return (
		<PaddingContainer className="gray-bg relative z-99 ">
			<WidthContainer className="z-9">
				<div className={styles.grid}>
					{Object.values(grid).map((column, index) => {
						return (
							column.condition && (
								<div
									key={index}
									className={classNames(styles.column, column.additionalStyles)}
								>
									{column.data.map((caseStudy) => (
										<GridCard key={caseStudy.slug} {...caseStudy} />
									))}
								</div>
							)
						);
					})}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
